<template>
  <a-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: { disabled: disabled } }"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row style="width: 100%">
          <a-col :span="24">
            <a-form-item label="通告标题" :wrapper-col="wrapperCol" :labelCol="labelCol">
              <a-input
                v-model="form.title"
                placeholder="请输入通告标题"
                style="width: 270px"
                :disabled="openType == 'details'"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%">
          <a-col :span="24">
            <a-form-item label="通告类型" :wrapper-col="wrapperCol" :labelCol="labelCol">
              <a-select
                v-model="form.msgType"
                style="width: 270px"
                @change="changeMSgType"
                :disabled="openType == 'details'"
                placeholder="请选择通告类型"
              >
                <!-- <a-select-option :value="1"> 待办事项 </a-select-option> -->
                <a-select-option :value="2"> 系统提醒 </a-select-option>
                <a-select-option :value="3"> 常用工具 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">
            <a-form-item :labelCol="labelColX1" :wrapperCol="wrapperCol" label="发布时间" class="publishTime">
              <el-date-picker
                style="width: 268px"
                :disabled="openType == 'details'"
                @change="changePT"
                :picker-options="pickerOptions"
                v-model="form.publishTime"
                type="datetime"
                placeholder="选择发布时间"
              >
              </el-date-picker>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%">
          <a-col :span="16">
            <a-form-item label="优先级" :wrapper-col="wrapperColX3" :labelCol="labelCol">
              <a-select
                v-model="form.priority"
                style="width: 270px; margin-left: 20px"
                @change="changePrior"
                :disabled="openType == 'details'"
                placeholder="请选择优先级"
              >
                <a-select-option value="L"> 低 </a-select-option>
                <a-select-option value="M"> 中 </a-select-option>
                <a-select-option value="H"> 高 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" v-if="textShow">
            <span style="color: red">优先级为【高】时，会强弹窗提示</span>
          </a-col>
        </a-row>
        <a-row style="width: 100%">
          <a-col>
            <a-form-item :labelCol="labelColX2" :wrapperCol="wrapperCol" label="发布系统">
              <a-checkbox
                value="0"
                :indeterminate="indeterminate"
                :checked="checkAll"
                @change="onCheckAllChange"
                :disabled="openType == 'details'"
              >
                全部
              </a-checkbox>
              <a-checkbox-group @change="changeSys" v-model="defaultList" :disabled="openType == 'details'">
                <a-checkbox value="60001"> 交易系统 </a-checkbox>
                <a-checkbox value="60002"> 信息资源库 </a-checkbox>
                <a-checkbox value="60012"> 自主采购 </a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item :labelCol="labelColX2" :wrapperCol="wrapperCol" label="发布对象">
              <a-checkbox
                value="0"
                :indeterminate="indeterminateObj"
                :checked="checkAllObj"
                @change="onCheckAllChangeObj"
                :disabled="openType == 'details'"
              >
                全部
              </a-checkbox>
              <a-checkbox-group @change="changeObj" v-model="defaultListObj" :disabled="openType == 'details'">
                <a-checkbox value="1"> 公司员工 </a-checkbox>
                <a-checkbox value="2"> 投标人/供应商 </a-checkbox>
                <a-checkbox value="3"> 招标人 </a-checkbox>
                <a-checkbox value="4"> 专家 </a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item :labelCol="labelColX2" :wrapperCol="wrapperCol" label="启用状态">
              <a-radio-group v-model="form.enableStatus" @change="onChangeEnable" :disabled="openType == 'details'">
                <a-radio :value="1"> 启用 </a-radio>
                <a-radio :value="0"> 禁用 </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%">
          <a-col :span="10" v-if="openType == 'add'">
            <a-form-item :labelCol="labelColX1" :wrapperCol="wrapperColX3" label="消息内容" class="j-field-content">
              <!-- <j-editor
								v-model="form.msgContent"
								:disabled="openType == 'details'"
								style="width: 800px"
								v-if="form.msgType != 3"
							></j-editor> -->
              <a-textarea
                v-model="form.msgContent"
                :disabled="openType == 'details'"
                :rows="7"
                :maxLength="2000"
                v-if="form.msgType != 3"
              ></a-textarea>
              <div v-else>
                <span style="margin-right: 10px">上传附件：</span>
                <a-upload
                  name="upfile"
                  :multiple="false"
                  :action="importExcelUrl"
                  :beforeUpload="beforeUpload"
                  :data="inputModalUrl.params"
                  :headers="headers"
                  @change="handleChange"
                >
                  <a-button> <a-icon type="upload" style="height: 20px" /> 选择附件 </a-button>
                </a-upload>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="10" v-else-if="openType == 'edit'">
            <div v-if="form.attachName">
              <span style="margin-right: 10px; font-weight: 600">消息内容：</span>
              {{ form.attachName }}
              <div>
                <a-upload
                  name="upfile"
                  :multiple="false"
                  :action="importExcelUrl"
                  :beforeUpload="beforeUpload"
                  :data="inputModalUrl.params"
                  :headers="headers"
                  @change="handleChange"
                >
                  <a-button> <a-icon type="upload" style="height: 20px" /> 选择附件 </a-button>
                </a-upload>
              </div>
            </div>
            <a-form-item
              v-else
              :labelCol="labelColX1"
              :wrapperCol="wrapperColX3"
              label="消息内容"
              class="j-field-content"
            >
              <!-- <j-editor
								v-model="form.msgContent"
								:disabled="openType == 'details'"
								style="width: 800px"
								v-if="form.msgType != 3"
							></j-editor> -->
              <a-textarea
                v-model="form.msgContent"
                :disabled="openType == 'details'"
                :rows="7"
                :maxLength="2000"
                v-if="form.msgType != 3"
              ></a-textarea>
              <div v-else>
                <span style="margin-right: 10px">上传附件：</span>
                <a-upload
                  name="upfile"
                  :multiple="false"
                  :action="importExcelUrl"
                  :beforeUpload="beforeUpload"
                  :data="inputModalUrl.params"
                  :headers="headers"
                  @change="handleChange"
                >
                  <a-button :disabled="isUpLoad"> <a-icon type="upload" style="height: 20px" /> 选择附件 </a-button>
                </a-upload>
              </div>
            </a-form-item>
          </a-col>
          <div v-else>
            <span v-if="form.attachName" style="margin-right: 10px; font-weight: 600"
              >消息内容：{{ form.attachName }}</span
            >

            <a-col :span="10" v-else>
              <a-form-item label="消息内容：" :labelCol="labelColX1" :wrapperCol="wrapperColX3" class="j-field-content">
                <a-textarea
                  v-model="form.msgContent"
                  :disabled="openType == 'details'"
                  :rows="7"
                  :maxLength="2000"
                ></a-textarea>
              </a-form-item>
            </a-col>
          </div>
        </a-row>
      </a-form>
    </a-spin>
    <!-- <select-user-list-modal ref="UserListModal" @choseUser="choseUser"></select-user-list-modal> -->
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import JDate from '@/components/jeecg/JDate'
import JEditor from '@/components/jeecg/JEditor'
import SelectUserListModal from './SelectUserListModal'
import moment from 'moment'
import { postAction } from '../../../api/manage'

export default {
  components: { JEditor, JDate, SelectUserListModal },
  name: 'SysAnnouncementModal',
  data() {
    return {
      openType: 'add',
      title: '操作',
      visible: false,
      disableSubmit: false,
      model: {},
      pickerOptions: {
        disabledDate(time) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return time.getTime() < Date.now() //选当前时间之前的时间
        }
      },
      headers: {
        'X-Access-Token': localStorage.getItem('userToken'),
        appId: '60000'
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelColX1: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      labelColX2: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperColX1: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      wrapperColX3: {
        xs: { span: 24 },
        sm: { span: 18 }
      },

      confirmLoading: false,
      form: this.$form.createForm(this),
      // validatorRules:{
      //   title:{rules: [{ required: true, message: '请输入标题!' }]},
      //   msgCategory:{rules: [{ required: true, message: '请选择消息类型!' }]},
      //   msgType:{rules: [{ required: true, message: '请选择通告对象类型!' }]},
      //   publishTime:{rules:[{ required: true, message: '请选择结束时间!'} ,{validator: this.endTimeValidate}]},
      //   msgAbstract:{rules: [{ required: true, message: '请输入摘要!' }]},
      // },
      url: {
        queryByIds: '/api/announcement/queryById',
        add: '/api/announcement/add',
        edit: '/api/sys/annountCement/edit'
      },
      form: {},
      userType: false,
      userIds: [],
      selectedUser: [],
      disabled: false,
      inputModalUrl: {
        // url:'api/sys/common/upload',
        url: '/uploader/notChunkUploader',
        params: null
      },
      indeterminate: false,
      checkAll: false,
      isUpLoad: false,
      checkAllObj: false,
      checkedList: ['0', '60001', '60002', '60012'],
      defaultList: [],
      defaultListObj: [],
      checkedListObj: ['0', '1', '2', '3', '4'],
      indeterminateObj: false,
      textShow: true
    }
  },
  computed: {
    downloadUrl() {
      console.log(this.inputModalUrl.url, 'this.inputModalUrl.url')
      return process.env.VUE_APP_FILE_API + this.inputModalUrl.url
    },
    importExcelUrl: function () {
      return process.env.VUE_APP_FILE_API + this.inputModalUrl.url
    }
  },
  mounted() {
    console.log(this.$parent, 'sdasda')
  },
  methods: {
    beforeUpload(file) {
      var fileType = file.type
      this.inputModalUrl.params = {
        filename: '',
        appPhotoGroup: '',
        appPhotoPath: ''
      }
      return true
    },
    onChangeEnable(e) {
      console.log(e, 'eee')
      this.form.enableStatus = e.target.value
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        defaultList: e.target.checked ? this.checkedList : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
      if (this.checkAll) {
        this.form.publishSys = this.checkedList.join(',')
      } else {
        this.form.publishSys = ''
      }
    },
    onCheckAllChangeObj(e) {
      Object.assign(this, {
        defaultListObj: e.target.checked ? this.checkedListObj : [],
        indeterminateObj: false,
        checkAllObj: e.target.checked
      })
      if (this.checkAllObj) {
        this.form.publishObj = this.checkedListObj.join(',')
      } else {
        this.form.publishObj = ''
      }
    },
    changeObj(ca) {
      this.checkAllObj = false
      this.form.publishObj = ca.join(',')
      if (ca.length == this.checkedListObj.length - 1) {
        this.checkAllObj = true
        this.indeterminateObj = true
      } else {
        this.checkAllObj = false
        this.indeterminateObj = false
      }
    },
    changeSys(ca) {
      if (ca.length == this.checkedList.length - 1) {
        this.checkAll = true
        this.indeterminate = true
      } else {
        this.checkAll = false
        this.indeterminate = false
      }
      this.checkAll = false
      this.form.publishSys = ca.join(',')
    },
    changeMSgType(val) {
      this.form.msgType = val
      if (val == 3) {
        this.textShow = false
      } else {
        this.textShow = true
      }
    },
    changePrior(val) {
      this.form.priority = val
    },
    add(type) {
      this.openType = type
      this.form = {}
      this.defaultList = []
      this.defaultListObj = []
      this.checkAll = false
      this.checkAllObj = false
      this.model = {}
      this.disable = false
      this.visible = true
      // this.getUser();
    },
    edit(record, type) {
      this.form = {}
      this.defaultList = []
      this.defaultListObj = []
      this.checkAll = false
      this.checkAllObj = false
      this.openType = type
      this.model = {}
      this.disable = false
      this.visible = true
      this.getUser(record)
    },
    changePT(val) {
      let date = moment(val).format('YYYY-MM-DD HH:mm:ss')
      this.form.publishTime = date
    },
    handleChange(val) {
      if (val.file.status == 'done') {
        if (val.file.response.success) {
          this.isUpLoad = true
          this.$message.success('上传成功')
          this.form.attachName = val.file.response.result.attachName
          this.form.attachPath = val.file.response.result.attachPath
          this.form.attachGroup = val.file.response.result.attachGroup
          this.form.attachSuffix = val.file.response.result.attachSuffix
        }
      }
    },
    getUser(record) {
      this.model = Object.assign({}, record)
      // 指定用户
      // this.userType =  true;
      // this.userIds = record.id;
      getAction(this.url.queryByIds, { id: record.id }).then((res) => {
        if (res.success) {
          this.form = res.result
          if (res.result.publishSys == '0' || res.result.publishSys.split(',').length == 4) {
            this.defaultList = this.checkedList
            this.checkAll = true
          } else {
            this.defaultList = res.result.publishSys.split(',')
          }
          if (res.result.publishObj == '0' || res.result.publishObj.split(',').length == 5) {
            this.defaultListObj = this.checkedListObj
            this.checkAllObj = true
          } else {
            this.defaultListObj = res.result.publishObj.split(',')
          }
          for (var i = 0; i < res.result.length; i++) {
            this.selectedUser.push(res.result[i].realname)
          }
          this.$refs.UserListModal.edit(res.result, this.userIds)
        }
      })
    },
    close() {
      this.loadData()
      this.$emit('close')
      this.selectedUser = []
      this.visible = false
    },
    handleOk() {
      console.log(this.$parent, 'sdasda')
      if (this.openType != 'details') {
        const that = this
        let httpReq = ''
        this.openType == 'add' ? (httpReq = '/api/announcement/add') : (httpReq = '/api/announcement/edit')
        console.log(this.form, 'asdasdasdas')
        postAction(httpReq, this.form)
          .then((res) => {
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.defaultListObj = []
              this.defaultList = []
              this.form = {}
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            that.$emit('ok')
            that.confirmLoading = false
          })
      } else {
        this.visible = false
      }
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
      this.resetUser()
    },
    resetUser() {
      this.userType = false
      this.userIds = []
      this.selectedUser = []
      this.disabled = false
      this.$refs.UserListModal.edit(null, null)
    },
    selectUserIds() {
      this.$refs.UserListModal.add(this.selectedUser, this.userIds)
    },
    chooseMsgType(value) {
      if ('USER' == value) {
        this.userType = true
      } else {
        this.userType = false
        this.selectedUser = []
        this.userIds = []
      }
    },
    // 子modal回调
    choseUser: function (userList) {
      this.selectedUser = []
      this.userIds = []
      for (var i = 0; i < userList.length; i++) {
        this.selectedUser.push(userList[i].realname)
        this.userIds += userList[i].id + ','
      }
    },
    startTimeValidate(rule, value, callback) {
      let publishTime = this.form.getFieldValue('publishTime')
      if (!value || !publishTime) {
        callback()
      } else if (moment(value).isBefore(publishTime)) {
        callback()
      } else {
        callback('开始时间需小于结束时间')
      }
    },
    endTimeValidate(rule, value, callback) {
      let startTime = this.form.getFieldValue('startTime')
      if (!value || !startTime) {
        callback()
      } else if (moment(startTime).isBefore(value)) {
        callback()
      } else {
        callback('结束时间需大于开始时间')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.publishTime {
  /deep/ .el-input--prefix .el-input__inner {
    height: 33px;
  }
}
/deep/ textarea.ant-input {
  width: 160%;
  max-width: 160%;
}
</style>
